// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HxUZiFz5n1DLSXkSfu8V {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem 0 5rem;
  width: 100%;
  z-index: 1000;
}
.HxUZiFz5n1DLSXkSfu8V iframe {
  width: 100%;
  max-width: 1000px;
  border: none;
  min-width: 320px;
}

@media screen and (max-width: 768px) {
  .HxUZiFz5n1DLSXkSfu8V {
    margin-bottom: -1rem;
  }
  .HxUZiFz5n1DLSXkSfu8V iframe {
    width: 90%;
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Subscribe/Subscribe.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AACF;AACE;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AACJ;;AAGA;EACE;IACE,oBAAA;EAAF;EACE;IACE,UAAA;IACA,eAAA;EACJ;AACF","sourcesContent":[".subscribeContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 2rem 0 5rem;\n  width: 100%;\n  z-index: 1000;\n\n  iframe {\n    width: 100%;\n    max-width: 1000px;\n    border: none;\n    min-width: 320px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .subscribeContainer {\n    margin-bottom: -1rem;\n    iframe {\n      width: 90%;\n      max-width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subscribeContainer": `HxUZiFz5n1DLSXkSfu8V`
};
export default ___CSS_LOADER_EXPORT___;
